module.exports = "https://www.gc-pro.gnp.com.mx/bb424c18bc0fa5df95896d227a0f6f2d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/camera2.svg
// module id = 8069
// module chunks = 0